export default {
  bgImg:
    'https://mylink.oss-accelerate.aliyuncs.com/newMyCity/9.1%E5%9C%B0%E5%9B%BE_SC%20.png',
  consultation:
    'https://mylink.oss-accelerate.aliyuncs.com/mycity/banner/activity_tc.png',
  cityImg:
    'https://mylink.oss-accelerate.aliyuncs.com/mycity/%E5%9F%8E%E5%B8%82%E5%9C%B0%E5%9B%BESC.png',
  mapImg:
    'https://mylink.oss-accelerate.aliyuncs.com/newMyCity/9.0.1/9.1%E5%9C%B0%E5%9B%BE_%E7%BC%A9%E7%95%A5%E5%9B%BE_SC.png',
  title1: '城市地图',
  title2: '个人之家',
  title3: '返回首页',
  title4: ' My功能',
  title5: '全部',
  title6: '城市地图',
  c1: '拖动页面查看更多建筑 , 精彩City等你慢慢逛',
  c2: '展开即可快速浏览寻找您想要的功能服务',
  c3: '打开CityMap , 可以知道您当前位置 , 还能快速抵达你想去的地方',
  c4: '点击气泡或建筑 , 将进入对应功能服务页面',
  c5: '下一步',
  c6: '我知道了',
  c7: 'skip',
  c8: '按此下拉返回',
  c9: '即将开放，敬请期待！'
}
